module.exports = __webpack_public_path__ + "static/media/G.93f0ffd3.svg";